module.exports = __webpack_public_path__ + "static/media/icicles.b14f5fe8.svg";